import(/* webpackMode: "eager" */ "/var/www/crmpl/src/app/installer/register/page.tsx");
